// src/components/stats/PlayerGameLog.jsx -- presentational condensed game log.
// One row per collected game (newest first), the focused stat highlighted. No
// misleading zeros: only the focused stat column is shown, and an inapplicable /
// no-participation value renders as "—", never 0 (§12/§A4). Enrichment columns
// (opponent, home/away, W/L) come from the v1a.1 route. Spec §C4.
//
// getValue is injected (StatsPage's registry-aware getStatValue bound to the
// focused stat) so this component performs no math.

import { resultColor } from '../../lib/player-stats-display';

function matchup(row) {
  if (!row.opponent_abbr) return '—';
  if (row.home_away === 'AWAY') return `@ ${row.opponent_abbr}`;
  if (row.home_away === 'HOME') return `vs ${row.opponent_abbr}`;
  // Side unresolved (opponent present, home_away null): show the opponent without
  // a home/away prefix rather than silently defaulting to "vs" (pre-Codex L3).
  return row.opponent_abbr;
}

export default function PlayerGameLog({ rows, statDef, getValue, highlightGameId = null }) {
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 }}>
        Recent games
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {rows.map((row) => {
          const v = getValue(row);
          const highlighted = highlightGameId != null && String(row.game_id) === String(highlightGameId);
          return (
            <div
              key={row.game_id}
              style={{
                display: 'grid', gridTemplateColumns: '64px 1fr 28px 48px', alignItems: 'center',
                gap: 8, borderRadius: 10, padding: '8px 12px',
                background: highlighted ? '#132244' : '#0b1626',
                border: `1px solid ${highlighted ? '#4f46e5' : '#1e293b'}`,
              }}
            >
              <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 700 }}>{String(row.game_date || '').slice(5)}</span>
              <span style={{ fontSize: 12, color: '#cbd5e1', fontWeight: 700 }}>{matchup(row)}</span>
              <span style={{ fontSize: 12, fontWeight: 800, color: resultColor(row.result) }}>{row.result || '—'}</span>
              <span style={{ fontSize: 14, fontWeight: 800, color: v === null ? '#64748b' : '#fff', textAlign: 'right' }}
                title={statDef?.label}>
                {v === null ? '—' : v}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
